import React, { useState } from 'react'
import ExperienceCard from '../components/ExperienceCard';
import ProjectCard from '../components/ProjectCard';
import pinch from '../assets/images/pinch/Pinch8.svg';
import inform from '../assets/images/inform/inform.png';
import arc from '../assets/images/arc/Arc.svg';
// import steg from '../assets/images/stegvision/Stegvision.png';
import htv from '../assets/images/htv/htv.svg';
import ribo from '../assets/images/ribo/RIBO - Cover.png';


function Design() {

    return (
        <div className='gap-8 columns-1 md:columns-2 lg:columns-3'>
            <ProjectCard
                bg='#F0E7E4'
                title='RIBO'
                link='ribo'
                tag='project'
                tagColour='#EEBDFF'
                img={ribo}
                desc='RIBO regulates and licenses Ontario’s insurance brokers, ensuring professionalism, compliance, and consumer protection.' />
            {/* <ExperienceCard
                bg='#60877D'
                title='Reshift Media'
                desc='A digital marketing company specializing in social media, search, software, and website design/development.'
                tag='experience'
                text='secondary'
                tagColour='#CBFB8F'
                current='current'
                link='reshift' /> */}
            <ProjectCard
                bg='#51688B'
                text='secondary'
                current='current'
                title='Inform Reviews'
                tagColour='#8baafb'
                img={inform}
                CTA='light'
                link='inform'
                desc='A hands-free review management tool that replies to weekly reviews and provides weekly insights using our automated assistant.'
                tag='startup project' />
            <ProjectCard
                bg='#BC9F76'
                title='Pinch'
                desc='Pinch’s mission is to provide local couriers and restaurants to keep their orders in their own hands.'
                tag='startup project'
                img={pinch}
                tagColour='#8baafb'
                link='pinch' />
            {/* <ExperienceCard
                bg='#876075'
                title='Freelance'
                tag='FREELANCE'
                text='secondary'
                tagColour='#AACBFD'
                link='freelance'
                desc='Freelancing is a where individuals offer services on a contractual basis to clients or businesses, typically on a project-by-project basis.' /> */}
            <ProjectCard
            text='secondary'
                bg='#495D44'
                title='Hack the Valley'
                CTA='light'
                tag='project'
                tagColour='#EEBDFF'
                link='htv'
                img={htv}
                desc='750 innovative and creative developers, designers, and creators for 36 hours of hacking. A hackathon that has been ongoing for seven years now. Hosted by University of Toronto.' />
            <ProjectCard
                bg='#F0E7E4'
                title='Arc AIO'
                tag='project'
                img={arc}
                tagColour='#EEBDFF'
                link='arc'
                desc='Arc AIO is an All-In-One collectibles and sneaker bot, supporting an expansive site list. Arc AIO gives users the advantage of copping the latest items in Canada.' />
            {/* <ProjectCard
                bg='#615A57'
                text='secondary'
                title='StegVision'
                link='stegvision'
                tag='freelance project'
                tagColour='#fb8bba'
                CTA='light'
                img={steg}
                desc='StegVision offers consumer level brand protection and fraud resolution that solves multi-billion dollar problems across industry.' /> */}
        </div>
    );
}

export default Design;